"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.header = void 0;
const basic_1 = require("../basic");
const colors_1 = require("../basic/colors");
const media_1 = require("../basic/media");
const spaces_1 = require("../basic/spaces");
exports.header = (0, basic_1.applyBase)({
    wrap: {
        borderBottom: '1px solid',
        borderColor: colors_1.colors.borderColor,
        position: 'relative',
        '.markup-control-button': {
            span: {
                height: '34px',
            },
        },
    },
    logo: {
        flexShrink: 0,
        img: {
            width: '98px',
            height: '34px',
            display: 'block',
            [media_1.media.tablet]: {
                width: '130px',
                height: '45px',
            },
        },
    },
    body: {
        display: 'flex',
        maxWidth: '1350px',
        minHeight: '60px',
        alignItems: 'center',
        padding: [`0 ${spaces_1.space[3]}`, `0 ${spaces_1.space[4]}`],
        margin: '0 auto',
        [media_1.media.tablet]: {
            minHeight: '64px',
        },
        '.language-control': {
            '.lang-button, .lang-dropdown-link': {
                height: '64px',
                width: '100%',
                px: 3,
            },
        },
        '.sub-links-list': {
            top: '65px',
        },
    },
});
//# sourceMappingURL=header.js.map